/*const url = {
  proxy: {
    prod: "https://drobertproxy.navandu.net/",
    stg: "https://drobertproxy-stg.navandu.net/"
  },
  navandume: {
    prod: "https://navandu.me/",
    stg: "https://navandume-stg.navandu.net/"
  }
};*/
//
const apiurl = {
  environment: 'stg',
  navandume: '', //this is overwritten after loading the config files in the store
  proxy: '',
  api2: 'api/v2.0/',
  api3: 'api/v3.0/',
  api1: 'api/v1.0/'
}

//apiurl.environment = process.env.VUE_APP_ENVIRONMENT

export default apiurl
